module.exports = __webpack_public_path__ + "img/iot3.1415a804.png";